import { render, staticRenderFns } from "./list.vue?vue&type=template&id=1447fa3c&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=1447fa3c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1447fa3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1447fa3c')) {
      api.createRecord('1447fa3c', component.options)
    } else {
      api.reload('1447fa3c', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=1447fa3c&scoped=true", function () {
      api.rerender('1447fa3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dental/clinic/list.vue"
export default component.exports